import { Component } from '@angular/core';

@Component({
  templateUrl: './my-bookshelf-page.component.html',
  styleUrl: './my-bookshelf-page.component.scss',
})
export class MyBookshelfPageComponent {}
